import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const YandexScaleMediumAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path
                    d="M11.9999 21.9796C17.5115 21.9796 21.9795 17.5116 21.9795 12C21.9795 6.48842 17.5115 2.02039 11.9999 2.02039C6.4883 2.02039 2.02026 6.48842 2.02026 12C2.02026 17.5116 6.4883 21.9796 11.9999 21.9796Z"
                    fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                />
                <path
                    d="M15.6111 18.2648H13.4204V7.42963H12.4445C10.6556 7.42963 9.71853 8.32408 9.71853 9.65926C9.71853 11.1741 10.3648 11.8759 11.7019 12.7704L12.8037 13.513L9.63705 18.263H7.28149L10.1315 14.0222C8.49261 12.8519 7.57038 11.7093 7.57038 9.78149C7.57038 7.37223 9.25001 5.73334 12.4296 5.73334H15.5963V18.2611H15.6111V18.2648Z"
                    fill="white"
                />
            </g>
        </svg>
    ),
    'Yandex'
);
export default YandexScaleMediumAppearanceDefault;
